<template>
    <modal ref="modal" class="login-modal" :body-class="{ 'pb-5': 1}">
        <h2 class="h2 text-center pb-3">
            Welcome back
        </h2>
        <p class="text-center">Log into your MySwitchPro account dashboard</p>
        <hr class="w-25">
        <div class="row">
            <div class="col-12 col-lg-10 mx-auto ">
                <login-form />
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "../Modal";
import LoginForm from "./LoginForm";

export default {
        name: "LoginModal",
        components: { LoginForm, Modal},
        methods: {
            show: function () {
                this.$refs.modal.show();
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/base";

    hr {
        &.w-25 {
            margin: 39px auto;
        }
    }

</style>
